export const toggleInViewClass = (isInView: boolean, element: Element, inviewClass: string, triggerOnce?: boolean): void => {
  if (!inviewClass) return
  if (isInView) {
    element.classList.add(inviewClass)
  } else {
    element.classList.remove(inviewClass)
  }
}
